import { Component, input } from '@angular/core';

/**
 * Presentational NPS-style ratings bar: given a ratings array, render proportional
 * segments and 0..5 endpoint labels.
 *
 * Ratings shape (as adjusted by FeedbackComponent): { rating, percentage, total }.
 */
@Component({
    selector: 'ft-ratings-meter',
    templateUrl: './ratings-meter.component.html',
    standalone: false
})
export class RatingsMeterComponent {
    readonly ratings = input<{ rating: number | string; percentage: number; total: number }[]>([]);
}
